// tslint:disable: variable-name

import { HIDE_ALL_HINTS } from "Data/Topics";
import { Button } from "GameObjects/Button";
import { MiniMusicGameButton } from "GameObjects/StoryGame/ch4/MiniMusicGameButton";
import { MiniMusicGameHolly } from "GameObjects/StoryGame/ch4/MiniMusicGameHolly";
import { SceneDraggable } from "GameObjects/StoryGame/SceneDraggable";
import { SceneSpine } from "GameObjects/StoryGame/SceneSpine";
import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import { ch4_p01 } from "../../../layouts/ch4_p01/ch4_p01"

export class Chapter4Page1 extends AbstractStoryState {

    readonly bg = this.addChild(new SceneSprite());
    readonly musicContainer = this.addChild(new PIXI.Container());
    readonly sections = [
        this.musicContainer.addChild(new SceneSprite()),
        this.musicContainer.addChild(new SceneSprite()),
        this.musicContainer.addChild(new SceneSprite()),
    ];

    readonly hh_ch4_p01psdAssetSec1Notes1Yellow = this.addChild(new SceneSprite());
    readonly hh_ch4_p01psdAssetSec1Notes2 = this.addChild(new SceneSprite());
    readonly hh_ch4_p01psdAssetSec1Notes3 = this.addChild(new SceneSprite());
    readonly hh_ch4_p01psdAssetSec1Notes5Red = this.addChild(new SceneSprite());

    readonly hh_ch4_p01psdAssetSec2Notes5blue = this.addChild(new SceneSprite());
    readonly hh_ch4_p01psdAssetSec2Notes4Yellow = this.addChild(new SceneSprite());

    readonly hh_ch4_p01psdAssetSec3Notes2Red = this.addChild(new SceneSprite());
    readonly hh_ch4_p01psdAssetSec3Notes1Blue = this.addChild(new SceneSprite());
    readonly hh_ch4_p01psdAssetSec3Notes3copy = this.addChild(new SceneSprite());
    readonly hh_ch4_p01psdAssetSec3Notes5Yellow = this.addChild(new SceneSprite());

    // because I didn't bother renaming them in the .fla file
    readonly musicNotesBySection = [
        [
            this.hh_ch4_p01psdAssetSec1Notes1Yellow,
            this.hh_ch4_p01psdAssetSec1Notes5Red,
            this.hh_ch4_p01psdAssetSec1Notes3,
            this.hh_ch4_p01psdAssetSec1Notes2,
        ],
        [
            this.hh_ch4_p01psdAssetSec2Notes5blue,
            this.hh_ch4_p01psdAssetSec2Notes4Yellow,
        ],
        [
            this.hh_ch4_p01psdAssetSec3Notes2Red,
            this.hh_ch4_p01psdAssetSec3Notes3copy,
            this.hh_ch4_p01psdAssetSec3Notes1Blue,
            this.hh_ch4_p01psdAssetSec3Notes5Yellow,
        ],
    ];

    readonly holly = this.addChild(new MiniMusicGameHolly());
    readonly buttonsContainer = this.addChild(new PIXI.Container());
    readonly buttons = list(() => this.buttonsContainer.addChild(new MiniMusicGameButton()));

    readonly audioFilesBySection = [
        [
            "ch4_p01_red_1",
            "ch4_p01_yellow_1",
            "ch4_p01_blue_1",
        ],
        [
            "ch4_p01_red_2",
            "ch4_p01_yellow_2",
            "ch4_p01_blue_2",
        ],
        [
            "ch4_p01_red_3",
            "ch4_p01_yellow_3",
            "ch4_p01_blue_3",
        ],
    ];

    protected queue: string[] = [];

    public init(pSize: PIXI.Point, pData: any) {
        // exported layouts from Animate CC
        ch4_p01.call(this);

        this.hh_ch4_p01psdAssetSec1Notes1Yellow.visible = false;
        this.hh_ch4_p01psdAssetSec1Notes2.visible = false;
        this.hh_ch4_p01psdAssetSec1Notes3.visible = false;
        this.hh_ch4_p01psdAssetSec1Notes5Red.visible = false;
        this.hh_ch4_p01psdAssetSec2Notes5blue.visible = false;
        this.hh_ch4_p01psdAssetSec2Notes4Yellow.visible = false;
        this.hh_ch4_p01psdAssetSec3Notes2Red.visible = false;
        this.hh_ch4_p01psdAssetSec3Notes1Blue.visible = false;
        this.hh_ch4_p01psdAssetSec3Notes3copy.visible = false;
        this.hh_ch4_p01psdAssetSec3Notes5Yellow.visible = false;

        this.sections.forEach(s => s.visible = false);

        this.holly.position.set(600, 1180); // eyeballed
        this.holly.scale.set(0.5);

        this._subscriptions.push([
            // callbacks from holly
            // TODO: constants instead of strings
            PubSub.subscribe('drop', this.onItemDropped.bind(this)),
            // PubSub.subscribe('wearing', this.onOutfitUpdate.bind(this)),
            // callbacks from buttons
            PubSub.subscribe(HLF.DRAG_BEGIN, this.onDragBegin.bind(this)),
            PubSub.subscribe(HLF.DRAGGABLE_SELECTED, this.onDragBegin.bind(this)),
            PubSub.subscribe(HLF.DRAG_END, this.onDragEnd.bind(this)),
            PubSub.subscribe(HLF.DRAGGABLE_DESELECTED, this.onDragEnd.bind(this)),
        ]);

        // super.init calls onResize
        super.init(pSize, pData);
        this.holly.update(0);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
        this.holly.update(pDeltaTime);
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
        // if (this.backButton) {
        //     this.backButton.position.y = (this.backButton.height / 2); // top right
        // }
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);
    }

    public animateOut(pOnComplete: () => void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        super.onAnimateInComplete();
    }

    protected onAllItemsDropped() {
        const track1 = Application.instance.audio.getAudioTrack(this.queue[0], HLF.AudioCategory.SFX)!;
        const track2 = Application.instance.audio.getAudioTrack(this.queue[1], HLF.AudioCategory.SFX)!;
        const track3 = Application.instance.audio.getAudioTrack(this.queue[2], HLF.AudioCategory.SFX)!;
        track1.on(HLF.HowlerUtils.Events.END, () => track2.play());
        track2.on(HLF.HowlerUtils.Events.END, () => track3.play());
        track3.on(HLF.HowlerUtils.Events.END, () => {
            this.gotoNextState({ transition: "left" });
        });

        track1.play();
        TweenLite.to(this.holly, 1, { pixi: { x: 832 } });
        this.holly.playAnimation("Playing", true);
    }

    // called *before* onDragEnd
    protected onItemDropped(pTopic: string, pData: HLF.Input.Draggable): void {
        // PubSub.publishSync(HIDE_ALL_HINTS, undefined);

        Application.instance.audio.play("HollySkirt", 0.5, false, HLF.AudioCategory.SFX); // TEMP

        const nextSection = this.sections.find(s => !s.visible);

        if (nextSection) {
            // TODO: store this data somewhere else
            const sectionIndex = this.musicContainer.getChildIndex(nextSection);
            const buttonIndex = this.buttonsContainer.getChildIndex(pData);

            // Application.instance.audio.load(audioFile, HLF.AudioCategory.SFX); // optional

            // fade in bars
            nextSection.FadeIn();

            const musicNotesForSection = this.musicNotesBySection[sectionIndex];

            // fade in and scale down music notes
            new TimelineMax().staggerFromTo(musicNotesForSection, 0.5,
                { pixi: { scale: 1.3 / 2, alpha: 0, visible: true } },
                { pixi: { scale: 1 / 2, alpha: 1, visible: true } },
                0.1 // stagger
            );

            const audioFile = this.audioFilesBySection[sectionIndex][buttonIndex];
            this.queue.push(audioFile);
            PubSub.publishSync('queue updated', this.queue);
        }

        // hide button
        pData.deselect();
        pData.visible = false;
        pData.interactive = false;

        if (this.queue.length === 3) {
            this.onAllItemsDropped();
        }
    }

    // called *after* onItemDropped
    protected onDragEnd(pTopic: string, pData: HLF.Input.Draggable): void {
        // if drag ended without dropping on holly, or item deselected
        if (pData && pData.interactive) {
            // reset button position and scale
            pData.visuals.position.set(0);
            pData.visuals.scale.set(1);

            // re-hint the item
            // this.showHint(pData);
        }

        this.holly.playAnimation("Idle", true);
    }

    protected onDragBegin(pTopic: string, pData: HLF.Input.Draggable): void {
        // hide hint on item
        this.hideHint(pData);

        this.holly.playAnimation("Getting Ready To Play", true);

        // show hint on holly
        // this.showHint({x: 400, y: 300}, "hand", 5);
    }
}